export const HopperRootCssClass = "hop";
export const StyledSystemRootCssClass = "hop-5-2-2";
export const HopperVariablePrefix = "--hop";

export type Theme = "sharegate" | "workleap";
